<template>
  <section v-if="generalHands.numberOfSpecificHandsInRange > 0" class="value-to-bluff-ratio panel-title">
    <span class="result">
      <div class="result-label">Value:</div>
      <div class="result-value">{{ percentOfSelectedRangeThatIsValue }}%</div>
    </span>
    <span class="result">
      <div class="result-label">Bluffs:</div>
      <div class="result-value">{{ percentOfSelectedRangeThatIsBluffs }}%</div>
    </span>
    <select v-model="idOfSelectedCutoffHand">
      <option v-for="hand in cutoffHands" v-bind:key="hand.id" v-bind:value="hand.id">
        {{ hand.name }}
      </option>
    </select>
    <a
      tabindex="0"
      role="button"
      class="glyphicon glyphicon-question-sign"
      data-toggle="popover"
      data-placement="top"
      data-trigger="focus"
      data-content="<p>Use the dropdown to select the cutoff hand. Example: If TPWK is selected, it means that everything TPWK and better is considered a value hand, and everything else is considered a bluff.</p><p>Think about whether the value-to-bluff ratio makes sense for your opponent. Is a nit really bluffing the river 85% of the time?</p>"
    ></a>
  </section>
</template>

<script>
export default {
  name: 'value-to-bluff-ratio',
  props: ['generalHands', 'communityCards'],
  data: function () {
    return {
      idOfSelectedCutoffHand: 'pair:tpwk',
      cutoffHands: [{
        name: 'Royal flush',
        id: 'fourOfAKindPlus:royalFlush',
      }, {
        name: 'Straight flush',
        id: 'fourOfAKindPlus:straightFlush',
      }, {
        name: 'Four of a kind',
        id: 'fourOfAKindPlus:fourOfAKind',
      }, {
        name: 'Full house',
        id: 'fullHouse',
      }, {
        name: 'Nut flush',
        id: 'flush:nut',
      }, {
        name: 'Second nut flush',
        id: 'flush:secondNut',
      }, {
        name: 'Third nut flush',
        id: 'flush:thirdNut',
      }, {
        name: 'Weak flush',
        id: 'flush:weak',
      }, {
        name: 'Straight',
        id: 'straight',
      }, {
        name: 'Top set',
        id: 'threeOfAKind:topSet',
      }, {
        name: 'Second set',
        id: 'threeOfAKind:secondSet',
      }, {
        name: 'Third set',
        id: 'threeOfAKind:thirdSet',
      }, {
        name: 'Fourth set',
        id: 'threeOfAKind:fourthSet',
      }, {
        name: 'Middle set',
        id: 'threeOfAKind:middleSet',
      }, {
        name: 'Bottom set',
        id: 'threeOfAKind:bottomSet',
      }, {
        name: 'Trips',
        id: 'threeOfAKind:trips',
      }, {
        name: 'Two pair using top board card',
        id: 'twoPair:usingTopBoardCard',
      }, {
        name: 'Weak two pair',
        id: 'twoPair:weak',
      }, {
        name: 'Overpair',
        id: 'pair:overpair',
      }, {
        name: 'TPTK',
        id: 'pair:tptk',
      }, {
        name: 'TPGK',
        id: 'pair:tpgk',
      }, {
        name: 'TPWK',
        id: 'pair:tpwk',
      }, {
        name: 'PP under TP',
        id: 'pair:ppUnderTp',
      }, {
        name: 'Second pair',
        id: 'pair:secondPair',
      }, {
        name: 'Middle pair',
        id: 'pair:middlePair',
      }, {
        name: 'Weak pair',
        id: 'pair:weakPair',
      }, {
        name: 'Ace high',
        id: 'highCard:aceHigh',
      }],
    };
  },
  computed: {
    percentOfSelectedRangeThatIsValue: function () {
      return this.generalHands.getPercentOfSelectedRangeThatIsValue(this.idOfSelectedCutoffHand, this.communityCards);
    },
    percentOfSelectedRangeThatIsBluffs: function () {
      return (100 - this.percentOfSelectedRangeThatIsValue).roundToTwoDecimalPlaces();
    },
  },
  mounted: function () {
    $(this.$el).find('[data-toggle="popover"]').popover({
      html: true
    });
  },
};
</script>

<style lang="scss" scoped>
  .value-to-bluff-ratio {
    display: inline-block;

    .result {
      display: inline-block;
      margin-right: 15px;

      .result-label {
        font-size: 7px;
      }

      .result-value {
        font-size: 16px;
      }
    }

    select {
      width: 150px;
    }

    @media (max-width: 500px) {
      select {
        width: 100px;
      }
    }

    @media (max-width: 450px) {
      select {
        width: 75px;
      }
    }

    @media (max-width: 400px) {
      select {
        display: none;
      }
    }

    .glyphicon-question-sign {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/value-to-bluff-ratio.vue